module.exports = __webpack_public_path__ + "img/5MM_20210901110054.06e2c821.png";